export const HOOK_URL = 'https://webhooks.fusion.usign.io';

export const HOOK_URL_ARTIST = '64cd04559ad3a6001313a6bd';

export const DEF_COLOR = 'E09900';
